<template>
  <main>
    <h2 class="ttl">
      <img
        src="/img/ico_mail.png"
        alt="メールアドレスの変更"
        width="40"
        class="mb30"
      /><br />{{ $t("changeEmail") }}
    </h2>
    <div class="account-box">
      <p class="txt-mail">
        <span>{{ $t("currentEmail") }}</span>
        <span class="value">{{ user.email }}</span>
      </p>
      <p class="txt-mail">
        <span v-if="!$v.email.required || !$v.email.email">{{
          $t(this.getMessage($v.email, { name: "新しいメールアドレス" }))
        }}</span>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Email"
          v-model.trim="$v.email.$model"
        />
      </p>
    </div>
    <p class="txt-error center mb40">
      <validationError :error="this.$v.$invalid && this.vaError" />
      <firebaseError :error="this.fbError" :errorCode="errorCode" />
    </p>
    <p class="btn-normal">
      <router-link to="" @click.native="updateEmail">{{
        $t("sendConfirmation")
      }}</router-link>
    </p>
    <modal
      name="input-password"
      :adaptive="true"
      width="100%"
      height="100%"
      :clickToClose="false"
    >
      <h2 class="ttl">{{ $t("enterPassword") }}</h2>
      <div class="room-name">
        <p>
          <input type="password" placeholder="Password" v-model="password" />
        </p>
      </div>
      <div class="center">
        <button class="mb20" @click="modalCompleted(false)">OK</button>
        <button class="cancel" @click="modalCompleted(true)">
          {{ $t("cancel") }}
        </button>
      </div>
    </modal>
  </main>
</template>

<script>
import firebase from "firebase";
import firebaseError from "@/error/FirebaseError";
import validationError from "@/error/ValidationError";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "AccountEmailEdit",
  data() {
    return {
      db: firebase.firestore(),
      user: firebase.auth().currentUser,
      email: "",
      password: "",
      vaError: false, //バリデーションエラー
      fbError: false, //firebaseエラー
      errorCode: "",
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  components: {
    firebaseError,
    validationError,
  },
  methods: {
    modalCompleted(isCancel) {
      if (isCancel) {
        this.$modal.hide("input-password");
        return;
      }
      if (!this.password) {
        return;
      }
      this.$modal.hide("input-password");
      this.reauthenticate();
    },
    async updateEmail() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.vaError = true;
        return;
      }
      try {
        let previousEmail = this.user.email;
        await this.user.updateEmail(this.email);
        const url =
          location.origin +
          this.$router.resolve({ name: "AccountEmailEditCompleted" }).href;
        const actionCodeSettings = { url: url };
        let phone = "";
        await this.db
          .collection("users")
          .doc(this.user.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              const data = doc.data();
              phone = data.phone;
            }
          });
        const updateLogRef = this.db.collection("usersUpdatesLog").doc();
        const logData = {
          uid: this.user.uid,
          updated_at: firebase.firestore.FieldValue.serverTimestamp(),
          from_email: previousEmail,
          to_email: this.email,
        };
        if (phone !== "") {
          logData.phone = phone;
        }
        await updateLogRef.set(logData);
        await this.user.sendEmailVerification(actionCodeSettings);
        this.$router.push({ name: "VerifyEmailSend" });
      } catch (error) {
        switch (error.code) {
          case "auth/requires-recent-login":
            this.$modal.show("input-password");
            return;
          default:
            this.errorCode = error.code;
            this.fbError = true;
            return;
        }
      }
    },
    async reauthenticate() {
      const credential = firebase.auth.EmailAuthProvider.credential(
        this.user.email,
        this.password
      );
      try {
        await this.user.reauthenticateWithCredential(credential);
        this.updateEmail();
      } catch (error) {
        this.errorCode = error.code;
        this.fbError = true;
      }
    },
  },
};
</script>

<style scoped>
.value {
  color: #333;
  font-size: 14px;
  padding-top: 10px;
}
</style>
